import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle2, ArrowRight, TrendingUp, AlertTriangle } from 'lucide-react';
export function TransformationSection() {
  const comparisons = [{
    before: 'Mirás videos sueltos y seguís perdido',
    after: 'Tenés un sistema claro para empezar de verdad',
    icon: 'system'
  }, {
    before: 'Gastás plata en productos que no necesitás',
    after: 'Invertís solo en lo que genera resultados',
    icon: 'money'
  }, {
    before: 'Cobrás barato por inseguridad',
    after: 'Cobrás con criterio y más confianza',
    icon: 'confidence'
  }, {
    before: 'Probás sin rumbo y perdés tiempo',
    after: 'Aplicás pasos concretos que funcionan',
    icon: 'time'
  }, {
    before: 'Seguís soñando con emprender',
    after: 'Empezás a generar ingresos reales',
    icon: 'dream'
  }];
  return <section className="py-24 px-4 bg-[#0a0a0a] relative overflow-hidden" data-id="element-417">
      {/* Background Accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(245,197,24,0.03),transparent_70%)] pointer-events-none" data-id="element-418" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-419">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-420">
          <h2 className="text-3xl md:text-5xl font-black mb-4 tracking-tighter uppercase italic" data-id="element-421">
            SIN RENOVA DETAIL <span className="text-gray-500" data-id="element-422">VS</span>{' '}
            <span className="text-brand-yellow" data-id="element-423">CON RENOVA DETAIL</span>
          </h2>
          
        </motion.div>

        <div className="space-y-4" data-id="element-424">
          {/* Header Labels - Desktop Only */}
          <div className="hidden md:grid grid-cols-2 gap-8 mb-6 px-8" data-id="element-425">
            <div className="flex items-center gap-2 text-red-500 font-black uppercase tracking-widest text-sm" data-id="element-426">
              <AlertTriangle className="w-4 h-4" data-id="element-427" />
              SEGUIR IMPROVISANDO
            </div>
            <div className="flex items-center gap-2 text-brand-yellow font-black uppercase tracking-widest text-sm" data-id="element-428">
              <TrendingUp className="w-4 h-4" data-id="element-429" />
              EMPEZAR CON VENTAJA
            </div>
          </div>

          {comparisons.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="group relative" data-id="element-430">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-8 bg-gradient-to-b from-[#151515] to-[#0d0d0d] rounded-2xl md:rounded-3xl border border-white/5 overflow-hidden transition-all duration-500 hover:border-brand-yellow/30 hover:shadow-[0_0_30px_rgba(245,197,24,0.05)]" data-id="element-431">
                {/* Negative Side */}
                <div className="p-6 md:p-8 border-b md:border-b-0 md:border-r border-white/5 relative group-hover:bg-red-500/[0.01] transition-colors" data-id="element-432">
                  <div className="flex items-start gap-4" data-id="element-433">
                    <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-red-500/10 flex items-center justify-center border border-red-500/20" data-id="element-434">
                      <X className="w-3.5 h-3.5 text-red-500" strokeWidth={3} data-id="element-435" />
                    </div>
                    <div data-id="element-436">
                      <span className="md:hidden block text-[10px] font-black text-red-500/60 uppercase tracking-widest mb-1" data-id="element-437">
                        Improvisando
                      </span>
                      <p className="text-gray-400 font-medium text-base md:text-lg leading-snug" data-id="element-438">
                        {item.before}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Positive Side */}
                <div className="p-6 md:p-8 relative bg-brand-yellow/[0.02] group-hover:bg-brand-yellow/[0.04] transition-colors" data-id="element-439">
                  <div className="flex items-start gap-4" data-id="element-440">
                    <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-brand-yellow/20 flex items-center justify-center border border-brand-yellow/40 shadow-[0_0_10px_rgba(245,197,24,0.2)]" data-id="element-441">
                      <CheckCircle2 className="w-3.5 h-3.5 text-brand-yellow" strokeWidth={3} data-id="element-442" />
                    </div>
                    <div data-id="element-443">
                      <span className="md:hidden block text-[10px] font-black text-brand-yellow/60 uppercase tracking-widest mb-1" data-id="element-444">
                        Con Ventaja
                      </span>
                      <p className="text-white font-bold text-base md:text-lg leading-snug" data-id="element-445">
                        {item.after}
                      </p>
                    </div>
                  </div>

                  {/* Subtle Glow Effect */}
                  <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-brand-yellow/[0.03] to-transparent pointer-events-none" data-id="element-446" />
                </div>

                {/* Center Arrow - Desktop Only */}
                <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#1a1a1a] border border-white/10 items-center justify-center z-20 group-hover:border-brand-yellow/50 group-hover:scale-110 transition-all duration-300" data-id="element-447">
                  <ArrowRight className="w-5 h-5 text-brand-yellow" data-id="element-448" />
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Bottom Call to Action Hint */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-449">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10" data-id="element-450">
            <div className="w-2 h-2 rounded-full bg-brand-yellow animate-pulse" data-id="element-451" />
            <p className="text-xs md:text-sm font-bold text-gray-400 uppercase tracking-widest" data-id="element-452">
              Tu transformación empieza hoy
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}